export default {
    // Currently used
    home_search_for_product: "Búsqueda para tu producto",
    conventional_alternative: "Alternativa Convencional",
    led_alternative: "Alternativa LED",
    search_filters_filter: "Filtro",
    alt_filters_filter: "Filtro Alternativa LED",
    search_submit: "Busca producto",
    results: "Resultados",
    selected_product: "Producto seleccionado",
    search_input: "Escribe (parte de)el código de producto o descriipción",
    what_type_are_you_looking_for: "¿Qué tipo de reemplazo de producto estás buscando?",
    recommendations_singular: "Recomendaciones",
    recommendations_plural: "Recomendaciones",
    your_product: "Tu Producto",
    search_filters_reset: "Resetea filtros",
    results_specify: "Hay más de 10 resultados, por favor especifica mejor tu búsqueda",
    energy_efficient: "Eficiente energéticamente",
    active_filters: "Activa filtros",
    card_action: "Catálogo",
    card_show_more: "Muestra más",
    card_show_less: "Muestra menos",
    card_alternative_fit: "Mejor Alternativa Philips",
    card_perfect_fit: "Mejor Ajuste Philips",
    no_results_found: "Resultados no encontrados. Por favor, pruebe una búsqueda diferente",
    results_no_recommendations: "¿Atascado? Comuníquese con su gestor de cuenta local o representante de ventas para encontrar una solución.",
    led_no_recommendations: "No hay alternativa LED para este producto",
    ballast_notice: "Es necesario comprobar la compatibilidad del equipo electrónico.",
    ballast_notice_tled_link_text: "Lista de compatibilidad TLED",
    ballast_notice_pl_led_link_text: "Lista de compatibilidad PL LED",
  
    // LED facets
    search_filter_product_type: "Tipo de producto",
    lighting_type: "Tipo de Lámpara",
    ean: "EAN",
    product_code: "Código de producto",
    eoc: "EOC",
    family: "Familia",
    discrete_wattage: "Vataje",
    wattage: "Vataje",
    brand: "Marca",
    driver_type: "Tipo de equipo",
    number_of_lamps: "Número de Lámparas",
    length: "Longitud",
    color: "Color",
    base: "Base",
    local_eoc: "Código Local",
    lumen: "Lumen",
    energy_saving: "El ahorro de energía",
    tiering: "Categoría",
    ballast_compatibility: "Compatibilidad de balasto",
    lifetime: "vida útil",

    // Conventional facets
    ignitor: "Arrancador",
    height: "Altura",
    width: "Anchura",
    mounting_hole: "Agujero de montaje",
    mains_voltage: "Directo a Red",
    thermal_protection: "Protección Térmica",
    delta_temperature: "Temperatura Delta",
    energy_efficiency: "Eficiencia energética",
    losses: "Pérdidas",
    lamp_current: "Corriente de la lámpara",
    pf_cap: "FP Casquillo (C)",
};
